import FundAllocationDetails from '@/models/fundAllocation/FundAllocationDetails';

export default {
  fundAllocations: [],
  fundAllocation: new FundAllocationDetails(),
};
